import { T } from './reportTokens';

type Props = {
    /** Lower-cased name of what failed — e.g. "sales by channel", "order log". Used in the message. */
    kpiName: string;
    onRetry?: () => void;
    /** 'small' fits inside tight cards; 'medium' for tables / larger panels. Defaults to 'small'. */
    size?: 'small' | 'medium';
    /** Optional custom height for the centering container. */
    minHeight?: number;
};

const SectionError = ({ kpiName, onRetry, size = 'small', minHeight }: Props) => {
    const isMedium = size === 'medium';
    const iconSize = isMedium ? 36 : 28;
    const textSize = isMedium ? 14 : 13;
    const buttonPad = isMedium ? '8px 22px' : '6px 18px';
    const buttonFontSize = isMedium ? 13 : 12;
    const containerMinHeight = minHeight ?? (isMedium ? 240 : 140);
    const gap = isMedium ? 14 : 10;

    return (
        <div
            role="alert"
            style={{
                flex: 1,
                minHeight: containerMinHeight,
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'center',
                gap,
                padding: '20px 12px',
                fontFamily: T.font,
                textAlign: 'center',
            }}
        >
            <svg
                aria-hidden
                width={iconSize}
                height={iconSize}
                viewBox="0 0 24 24"
                fill="none"
                stroke={T.t2}
                strokeWidth="1.6"
                strokeLinecap="round"
                strokeLinejoin="round"
            >
                <path d="M10.29 3.86 1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0Z" />
                <line x1="12" y1="9" x2="12" y2="13" />
                <line x1="12" y1="17" x2="12.01" y2="17" />
            </svg>
            <div style={{ fontSize: textSize, color: T.accent, lineHeight: 1.45 }}>
                Unable to load {kpiName}. Please try again.
            </div>
            {onRetry && <button
                type="button"
                onClick={onRetry}
                style={{
                    background: T.surface,
                    color: T.t1,
                    border: `1px solid ${T.cardBorder}`,
                    borderRadius: 8,
                    padding: buttonPad,
                    fontSize: buttonFontSize,
                    fontWeight: 600,
                    cursor: 'pointer',
                    fontFamily: T.font,
                    boxShadow: T.cardShadow,
                }}
            >
                Retry
            </button>}
        </div>
    );
};

export default SectionError;
